import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { CardTemplateDb } from '../redux/cardTemplateDbSlice';
import { BookDb } from '../redux/bookDbSlice';
import { PaletteDb } from '../redux/paletteDbSlice';

type AddPlaceType = { place: string; } & (CardTemplateDb | BookDb | PaletteDb);
const useGetInstalledGoods = (): [string[], AddPlaceType[]] => {
  const cardTemplates = useSelector((state: RootState) => state.cardTemplateDb.cardTemplates);
  const books = useSelector((state: RootState) => state.bookDb.books);
  const palettes = useSelector((state: RootState) => state.paletteDb.palettes);
  const rPCTs = useSelector((state: RootState) => state.relationPaletteCardTemplateDb.relationPaletteCardTemplates);
  const folders = useSelector((state: RootState) => state.folderDb.folders);
  const rFBs = useSelector((state: RootState) => state.relationFolderBookDb.relationFolderBooks);

  const cardTemeplateIds = Object.keys(cardTemplates).filter(id => cardTemplates[id].goodsId);
  const cardTemplateValues: AddPlaceType[] = cardTemeplateIds.map(id => {
    const value = cardTemplates[id];
    const rPCTId = Object.keys(rPCTs).find(targetId => rPCTs[targetId].cardTemplateId === id);
    if (!rPCTId) return { ...value, place: '' };
    const place = palettes[rPCTs[rPCTId].paletteId].name;
    return { ...value, place };
  });

  const bookIds = Object.keys(books).filter(id => books[id].goodsId);
  const bookValues = bookIds.map(id => {
    const value = books[id];
    const rFBId = Object.keys(rFBs).find(targetId => rFBs[targetId].bookId === id);
    if (!rFBId) return { ...value, place: '' };
    const place = folders[rFBs[rFBId].folderId].name;
    return { ...value, place };
  });

  const paletteIds = Object.keys(palettes).filter(id => palettes[id].goodsId);
  const paletteValues: AddPlaceType[] = paletteIds.map(id => { return { ...palettes[id], place: '' };});

  const ids = cardTemeplateIds.concat(bookIds, paletteIds);
  const values = cardTemplateValues.concat(bookValues, paletteValues);

  return [ids, values];
}

export default useGetInstalledGoods;
